var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunityEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 177,
    height: 156,
    viewBox: "0 0 177 156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "wdkmu6z9ca",
    width: "125%",
    height: "700%",
    x: "-12.5%",
    y: "-300%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 3.24
  })), /*#__PURE__*/React.createElement("path", {
    id: "vqk2mn59hb",
    d: "M0.478 0.461L113.57 0.461 113.57 78.36 0.478 78.36z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFCB00",
    d: "M38.95 77.898h35.192c21.512 0 38.95-17.439 38.95-38.95C113.092 17.438 95.654 0 74.142 0H38.95C17.439 0 0 17.439 0 38.948c0 21.511 17.439 38.95 38.95 38.95",
    transform: "translate(0 .319) translate(0 18.71)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCB00",
    d: "M49.013 70.924L20.989 99.52c-2.138 2.18-5.844.667-5.844-2.385V62.42l33.868 8.503z",
    transform: "translate(0 .319) translate(0 18.71)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFE479",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8.9,
    d: "M26.019 28.827L89.476 28.827M26.019 45.624L50.106 45.624",
    transform: "translate(0 .319) translate(0 18.71)"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#7A6130",
    transform: "translate(0 .319) translate(46 141.681)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.539,
    style: {
      mixBlendMode: "soft-light"
    },
    cx: 46.44,
    cy: 3.24,
    rx: 46.44,
    ry: 3.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.269,
    style: {
      mixBlendMode: "multiply"
    },
    cx: 46.44,
    cy: 4.32,
    filter: "url(#wdkmu6z9ca)",
    rx: 38.88,
    ry: 1.62
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .319) translate(63.3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFA00",
    d: "M74.62 78.36H39.429C17.917 78.36.478 60.921.478 39.41.478 17.9 17.917.46 39.428.46h35.193c21.51 0 38.95 17.439 38.95 38.95 0 21.511-17.44 38.95-38.95 38.95"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.952,
    cy: 42.522,
    r: 20.5,
    fill: "#FFCB00"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFA00",
    d: "M64.558 71.384L92.582 99.98c2.136 2.182 5.844.667 5.844-2.385V62.883l-33.868 8.501z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F8E71C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6.408,
    d: "M57.024 34.898L57.024 44.195 63.804 44.195"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFCB00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6.408,
    d: "M50.638 15.657L60.413 15.657"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityEmpty);
export default __webpack_public_path__ + "static/media/communityEmpty.84fc90af90c3912657942f6df9394155.svg";
export { ForwardRef as ReactComponent };